/* eslint-disable no-magic-numbers,no-bitwise */
/**
 * Converts a hex string to an array of byte values
 *
 * For the browser environment. In a Node-environment, you'd use Buffer instead of this implementation.
 */
export function hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let c = 0; c * 2 < hex.length; c++) {
        bytes[c] = parseInt(hex.substring(c * 2, c * 2 + 2), 16);
    }
    return bytes;
}
/**
 * Converts an array of byte values to a hex string
 *
 * For the browser environment. In a Node-environment, you'd use Buffer instead of this implementation.
 *
 * @see https://github.com/brix/crypto-js/blob/31d00127a7c87066c51abe56e7b8be3a32141cae/core.js#L390
 */
export function bytesToHex(bytes) {
    const hex = [];
    for (const byte of bytes) {
        const current = byte < 0 ? byte + 256 : byte;
        hex.push((current >>> 4).toString(16));
        hex.push((current & 0xf).toString(16));
    }
    return hex.join("");
}
//# sourceMappingURL=hex.js.map